import { LANG_MAP_REVERSED } from 'constants/app/lang-map';

export const getUrlParams = (
  keys: string[] = []
): Record<string, string[] | undefined> => {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObj: Record<string, string[] | undefined> = {};

  keys.forEach(key => {
    if (searchParams.get(key)) {
      paramsObj[key] = searchParams.get(key)?.split(',');
    }
  });

  return paramsObj;
};

export const getDocumentLanguage = (
  mode: 'short' | 'long' = 'short'
): string => {
  const html = document.querySelector('html');
  const lang = html?.getAttribute('lang') || 'en';
  return mode === 'short'
    ? LANG_MAP_REVERSED[lang.toLowerCase()] || 'en'
    : lang;
};
